import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const FilePreview = ({ row, onClose }) => (
  <Dialog open={!!row} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-w-4xl p-0 overflow-hidden" data-testid="import-file-preview">
      <DialogHeader className="px-5 py-3 border-b border-slate-200">
        <DialogTitle className="text-base truncate pr-6">{row?.file.name}</DialogTitle>
      </DialogHeader>
      <div className="h-[75vh] bg-slate-50">
        {row && (row.file.type.startsWith("image/")
          ? <img src={row.url} alt={row.file.name} className="w-full h-full object-contain" />
          : <iframe src={row.url} title={row.file.name} className="w-full h-full border-0" />)}
      </div>
    </DialogContent>
  </Dialog>
);
